module.exports = __webpack_public_path__ + "static/media/anunciar-imovel-anage.feccebaa.svg";